import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '@/lib/api';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { ArrowLeft, Calendar, Eye, User } from 'lucide-react';

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/blog/posts/${slug}`).then(r => setPost(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="max-w-3xl mx-auto px-4 py-12"><Skeleton className="h-8 w-2/3 mb-4" /><Skeleton className="h-64" /></div>;
  if (!post) return <div className="max-w-3xl mx-auto px-4 py-12 text-center"><p className="text-muted-foreground">Post nie znaleziony</p><Link to="/blog"><Button variant="outline" className="mt-4">Wroc do bloga</Button></Link></div>;

  return (
    <article className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
      <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-6"><ArrowLeft className="h-4 w-4" />Wroc do bloga</Link>
      {post.image_url && <div className="aspect-video rounded-xl overflow-hidden mb-8 bg-muted"><img src={post.image_url} alt={post.title} className="w-full h-full object-cover" /></div>}
      <div className="flex flex-wrap gap-2 mb-4">{post.tags?.map(t => <Badge key={t} variant="secondary" className="text-xs">{t}</Badge>)}</div>
      <h1 className="font-heading text-3xl md:text-4xl font-bold tracking-tight">{post.title}</h1>
      <div className="flex items-center gap-4 mt-4 text-sm text-muted-foreground">
        <div className="flex items-center gap-1.5"><User className="h-3.5 w-3.5" />{post.author}</div>
        <div className="flex items-center gap-1.5"><Calendar className="h-3.5 w-3.5" />{post.published_at?.slice(0, 10)}</div>
        <div className="flex items-center gap-1.5"><Eye className="h-3.5 w-3.5" />{post.views} wyswietl.</div>
      </div>
      <div className="mt-8 prose prose-invert prose-sm max-w-none" dangerouslySetInnerHTML={{ __html: post.content || post.excerpt }} />
    </article>
  );
}
